/* eslint-disable-next-line no-restricted-imports */
import { createSelector as createSelectorUntyped } from '@reduxjs/toolkit'
import type { RootState } from 'APP/Store/CreateStore'

export const createSelector = createSelectorUntyped.withTypes<RootState>()
